import React from 'react';
import { translate } from 'core/utils';
import _ from 'lodash';

function TableMethodInjectTemplate(props) {
	const { item, column } = props;

	let data = item[column.key];
	if (column.extra) {
		data = column.extra(props);
		if (data && _.isArray(data) && data[0] && _.isArray(data[0])) {
			// Data is table
			let innerKey = 0;
			data = (
				<table>
					<tbody className="table__truncate__row">
						{_.map(data, row => {
							innerKey++;
							let key = column.key + innerKey;
							return (
								<tr key={key}>
									{_.map(row, (col, idx) => {
										innerKey++;
										let key = column.key + innerKey;
										return (
											<td key={key}>
												{/* No need to tooltip the first column and only use tooltip when necessary */}
												{idx !== 0 && col.length > 30 ? (
													<div className="table__truncate__item" title={col}>
														{col && col != '' ? col : '/'}
													</div>
												) : (
													<div className="table__truncate__item">{col && col != '' ? col : '/'}</div>
												)}
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			);
		}
	}
	return (
		<td key={column.key} className="table__body--data">
			{data}
		</td>
	);
}

export default TableMethodInjectTemplate;
